<template>
    <BaseDialog
        :showDialog="showSelectionRequiredDialog"
        maxDialogWidth="400"
        headline="lang_GENERAL_SELECTION_REQUIRED_DIALOG_TITLE"
        :close="() => showSelectionRequiredDialog = false"
        alvqa="selection-required-dialog"
    >
        <template v-slot:dialogText>
            <v-container>
                <v-row>
                    <v-col alvqa="selection-required-dialog-text">{{ $t(selectionRequiredText) }}</v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '../_base/BaseDialog'
import BaseButton from '../_buttons/BaseButton'

export default {
    name: "SelectionRequiredDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    computed: {   
        /** Returns an individual "Selection Required"-Text.
         *  @return {String} the dialog text. */     
        selectionRequiredText() { return this.$store.getters.getSelectionRequiredText },

        showSelectionRequiredDialog: {
            get() { return this.$store.getters.getShowSelectionRequiredDialog},
            set(showSelectionRequiredDialog) { this.$store.commit('setShowSelectionRequiredDialog', showSelectionRequiredDialog) }
        }
    }
}
</script>
